export const formatNumber = (price: number, maximumFractionDigits = 2): string => {
   return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits,
   }).format(price);
};
